import { Building2, HandHeart } from 'lucide-react';
import ReglasDelGrupo from '../escala/ReglasDelGrupo';
import MiFirma from '../escala/MiFirma';

/* =====================================================================
   Las pantallas del carril `escala` · Fase E3
   =====================================================================
   El menú las monta solo. Este carril no toca `ui/modulos.jsx`, que es
   el archivo caliente: se deja el archivo aquí y aparece.

   LAS DOS VAN EN «Control» y no en un grupo propio, y es deliberado:
   quien busca «a partir de cuánto hace falta una firma» ya sabe mirar
   ahí, porque es donde están las reglas de su empresa desde Accesos
   Fase 3. Un grupo «Grupo de empresas» separaría dos cosas que se
   consultan seguidas.

   `soloEmpresa` NO se pone en ninguna de las dos: las dos son de la
   empresa en la que estás. La de grupo pinta un estado vacío que
   explica qué es esto cuando la empresa no pertenece a ninguno, en vez
   de esconderse — quien no sabe que existe no lo pide.
   ===================================================================== */
export default {
  orden: 60,
  grupos: [{
    grupo: 'Control',
    items: [
      {
        id: 'escala-reglas-de-grupo',
        etiqueta: 'Reglas para todas las empresas del grupo',
        icono: Building2,
        min: 'DUENO',
        Comp: ReglasDelGrupo,
      },
      {
        id: 'escala-mi-firma',
        etiqueta: 'Mi firma de autorización',
        icono: HandHeart,
        min: 'ENCARGADO',
        Comp: MiFirma,
      },
    ],
  }],
};
